module.exports = __webpack_public_path__ + "static/media/sign-in.fd815b7e.png";